import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateDatePicker(nodeFields, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetDatePicker(richAssetField?.content))
        return;
    if (ast.isStringField(richAssetField.content.value) ||
        ast.isEmptyField(richAssetField.content.value)) {
        // Add a deprecation warning
        accept('warning', `String content for datepicker is being deprecated. Please use the new JSON format.`, {
            node: richAssetField,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
        // Message string is required. It cannot be an empty string
        if (ast.isEmptyField(richAssetField.content.value)) {
            accept('error', `Missing required 'message' value.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
    }
    else if (ast.isDatePickerJson(richAssetField.content.value)) {
        const datePickerJson = richAssetField.content.value;
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: datePickerJson,
            allProperties: datePickerJson.properties,
            requiredProperties: [ast.TypeStaticProperty, ast.MessageProperty],
            parentNode: nodeFields.refNode,
            accept,
        });
    }
}
//# sourceMappingURL=date-picker.js.map